export default function getDefer(msReject = 0) {
    let resolve, reject;
    const promise = new Promise((_resolve, _reject) => {
        reject = _reject;
        resolve = _resolve;
        msReject &&
            setTimeout(() => {
                reject(new Error('timeout'));
            }, msReject);
    });
    // @ts-expect-error
    return { promise, resolve, reject };
}
